module.exports = __webpack_public_path__ + "static/img/Lama-Afu.bd38a5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lama-Afu.jpg
// module id = AAlT
// module chunks = 0